<div *ngIf="hasErrors || reviewIntent" class="message-container">
  <button
    mat-raised-button
    class="errors-btn"
    color="warn"
    (click)="showCheckupDialog()"
    *ngIf="hasErrors"
  >
    Sono stati individuati alcuni problemi sull'itinerario
  </button>
  <button
    mat-raised-button
    class="review-btn"
    (click)="showReviewDialog()"
    *ngIf="hasErrors === false && reviewIntent"
  >
    Procedi ad inviare in revisione l'itinerario
  </button>
</div>

<mat-spinner
  class="iframe-spinner"
  *ngIf="!rendered || (reviewIntent && hasErrors === null)"
></mat-spinner>

<div
  class="iframe-container"
  #iframeContainer
  [ngClass]="{ blurred: !rendered || (reviewIntent && hasErrors === null) }"
>
  <iframe [src]="previewIframeUrl" #iframe></iframe>
</div>
